import React, { type ReactNode } from 'react'
import { useTranslation, withTranslation } from 'react-i18next'
import { Wrap, Title, ButtonWrapper } from './ui-info-modal.styled'
import { BackdropClickModal } from '../core/modal/modal'
import { Button } from '../button/ui-button'

interface UiModalButton {
  text: string
  onClick?: () => void
  format?: 'blue' | 'transparent'
}
interface UiInfoModalProps {
  open: boolean
  title?: string
  onClose: () => void
  maxWidth?: number
  titlePosition?: 'right' | 'left' | 'center'
  titleSize?: 'medium' | 'large'
  buttons?: {
    preset: 1 | 2 | 3
    items?: UiModalButton[] // ltr
    position?: 'start' | 'end' | 'center'
    stretch?: boolean
  }
  children: React.ReactNode
}

const UiInfoModal: React.FC<UiInfoModalProps> = ({
  open, title, onClose, maxWidth = 800, titlePosition = 'left', children,
  titleSize = 'medium',
  buttons = {
    preset: 1,
    items: [{ text: 'Зрозуміло', format: 'blue' }],
    position: 'end',
    stretch: false
  }
}) => {
  const { t } = useTranslation()

  const buttonPreset = (items?: UiModalButton[]): ReactNode => {
    const renderButtons = (isAutoMargin: boolean = false): ReactNode[] => (
      items?.map((button, index) => (
        <Button
          key={button.text}
          format={button.format ?? 'blue'}
          style={isAutoMargin && index === 0 ? { marginRight: 'auto' } : {}}
          onClick={button.onClick ?? onClose}
        >
          {button.text ?? t('Зрозуміло')}
        </Button>
      )) ?? [
        <Button
          key={0}
          format='blue'
          onClick={onClose}
          style={buttons.stretch ? { width: '100%' } : {}}
        >
          {t('Зрозуміло')}
        </Button>
      ]
    )

    const presetConfig = {
      1: <ButtonWrapper $buttonPosition={buttons.position ?? 'end'}>
            {renderButtons().slice(0, 1)}
         </ButtonWrapper>,
      2: <ButtonWrapper $buttonPosition='end'>
            {renderButtons()}
         </ButtonWrapper>,
      3: <ButtonWrapper $buttonPosition='end'>
            {renderButtons(true)}
         </ButtonWrapper>
    }

    return presetConfig[buttons.preset]
  }

  return (
    <BackdropClickModal
      open={open}
      disableEscapeKeyDown={true}
      onClose={onClose}
    >
      <Wrap $maxwidth={maxWidth}>
        {title && <Title $titlePosition={titlePosition} $titleSize={titleSize}>{title}</Title>}
        <div style={{ overflowY: 'auto' }}>{children}</div>
        {buttonPreset(buttons.items)}
      </Wrap>
    </BackdropClickModal>
  )
}

export default withTranslation('dzo')(UiInfoModal)
